'use client';

import { Button } from '@tremor/react';
import { useRouter } from 'next/navigation';
import { ReactElement, useCallback } from 'react';
import { CY_SELECTORS } from '../../cypress/constants';
import { DEFAULT_ERROR_MESSAGE } from '../commons/constants/constants';
import { addCypressSelector } from '../commons/utils/utils';
import { useAppDispatch, useAppSelector } from '../redux';
import { cleanError } from '../redux/slices/errorSlice';
const ErrorScreen = (): ReactElement => {
  const errorState: ErrorState = useAppSelector(state => state.error);
  const dispatch = useAppDispatch();
  const router = useRouter();
  const handleGoBack = useCallback((): void => {
    if (errorState.redirectPath) {
      router.replace(errorState.redirectPath);
    }
    dispatch(cleanError());
  }, [dispatch, router, errorState.redirectPath]);
  if (!errorState.show) {
    return <></>;
  }
  return <div className='absolute inset-0 bg-white text-black flex flex-col items-center justify-center p-8 z-50' data-sentry-component="ErrorScreen" data-sentry-source-file="errorScreen.tsx">
      <h1 className='text-3xl font-bold mb-4'>Oops! Something went wrong.</h1>
      <p {...addCypressSelector(CY_SELECTORS.ERROR_SCREEN_TEXT)} className='mb-6 w-11/12 md:w-2/3 lg:w-1/2 xl:w-2/5 text-xs'>
        {errorState?.message && typeof errorState.message === 'string' ? errorState.message : DEFAULT_ERROR_MESSAGE}
      </p>
      <Button onClick={handleGoBack} className='bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-300' data-sentry-element="Button" data-sentry-source-file="errorScreen.tsx">
        Go Back
      </Button>
    </div>;
};
export default ErrorScreen;